import { useState } from "react";
import FaqView from "./view";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sendMessage } from "@/redux/ducks/user";
import { SendMessageAction } from "@/redux/sagas/faq/sendMessage";
import { getIsValidString, validateEmail } from "@/utils/functions";

export default function Contact() {
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(false);
	const [isVisibleModal, setIsVisibleModal] = useState(false);

	const goBack = () => navigate(-1);

	const toggleModal = () => {
		if (isVisibleModal && !error) goBack();
		setIsVisibleModal(isVisibleModal => !isVisibleModal)
	};

	const getIsDisabled = () => {
		return !getIsValidString(name) || !validateEmail(email) || !getIsValidString(message);
	}

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		if (name === "name") {
			setName(value);
		}
		if (name === "email") {
			setEmail(value);
		}
	}

	const onChangeMessage = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const { value } = e.target;
		setMessage(value);
	}

	const handleSendMessage = (success: boolean) => {
		setIsLoading(false);

		if (!success) {
			setError(true);
			setIsVisibleModal(true);
			return;
		}

		setIsVisibleModal(true);
	}

	const submit = () => {
		if (getIsDisabled()) return;

		if (isLoading) return;

		setIsLoading(true);
		setError(false);

		dispatch(
			sendMessage({
				name,
				email,
				message,
				callback: handleSendMessage,
			} as SendMessageAction['payload'])
		);
	}

	return (
		<FaqView
			goBack={goBack}
			onChange={onChange}
			submit={submit}
			name={name}
			email={email}
			message={message}
			isDisabled={getIsDisabled()}
			isLoading={isLoading}
			error={error}
			onChangeMessage={onChangeMessage}
			isVisibleModal={isVisibleModal}
			toggleModal={toggleModal}
		/>
	);
}
